import {Card} from "@material-ui/core";
import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {UserClientForm} from "./UserClientForm";

export const UserClientEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component={Card}>
      <UserClientForm />
    </DefaultEdit>
  );
};
